import React ,{useEffect,useState} from 'react';
import { useLocation,useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";


function AddPayment() {
const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const paymentId = queryParams.get("id"); // <-- null for Add, string for Edit
    const navigate = useNavigate();
  const token = localStorage.getItem("token");

const [formdata, setForm] = useState({ oid:"",cid: "",amount:"", method: "" ,trans_id:"",status:""});
      const [errors, setErrors] = useState({});
      const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState("");
    

      useEffect(() => {
    if (paymentId) {
      const fetchPayment = async () => {
        try {
          const { data } = await apiClient.get(ADMIN.GET_PAYMENT);
          if (data.success) {
            const payment = data.items.find(p => p._id === paymentId);
            if (payment) {
              setForm({
                oid: payment.order_id,
                cid: payment.customer_id,
                amount: payment.amount,
                method: payment.method,
                trans_id: payment.transaction_id,
                status: payment.status
              });
            }
          }
        } catch (err) {
          console.error("Error fetching payment:", err);
          toast.error(err.response?.data?.message || err.message || "Failed to fetch payment data");
        }
      };
      fetchPayment();
    }
  }, [paymentId]);

      const validate = () => {
        const e = {};
        if (!formdata.oid )
          e.oid = "Order Id Requiered";
        if (!formdata.cid)
          e.cid = "Customer Id required";
        if (!formdata.amount) 
          e.amount="Amount required";
        if (!formdata.method) 
        e.method="Method required";
        if (!formdata.trans_id)
        e.trans_id= "Transaction Id required";
        if (!formdata.status) 
          e.status = "Status required";
        setErrors(e);
        return Object.keys(e).length === 0;
      };
    
      const formChangeData = (ev) => {
        const { name, value } = ev.target;
            
            setForm((f) => ({ ...f, [name]: value }));
          
          setMessage("");
      };
    
      const handleSubmit = async (ev) => {
      ev.preventDefault();
      if (!validate()) return;
      setLoading(true);
      setMessage("");
  

  try {
    const url = paymentId ? ADMIN.UPDATE_PAYMENT(paymentId) : ADMIN.ADD_PAYMENT;
    const method = paymentId ? "put" : "post";
      
    const { data } = await apiClient[method](url, formdata);
    if (!data.success) throw new Error(data?.message || "Operation failed");

    toast.success(data.message || (paymentId ? "Payment updated successfully" : "Payment added successfully"));
    if (!paymentId) {
        setForm({ oid:"", cid:"", amount:"", method:"", trans_id:"", status:"" });
    }

    setTimeout(() => {
      navigate("/payment");
    }, 1000);
    } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Operation failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <div>
        
      <div className="col-12 grid-margin container-scroller" >
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title"></h4>
                    <form method="post" onSubmit={handleSubmit} className="form-sample">
                      <p className="card-description"> Add Payment </p>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Order Id</label>
                            <div className="col-sm-9">
                              <input type="text" name="oid" value={formdata.oid} onChange={formChangeData} className="form-control" />
                              {errors.oid && <small className="text-danger">{errors.oid}</small>}
                            </div>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Customer Id</label>
                            <div className="col-sm-9">
                              <input type="text" name="cid" value={formdata.cid} onChange={formChangeData} className="form-control" />
                              {errors.cid && <small className="text-danger">{errors.cid}</small>}
                            </div>
                          </div>
                        </div>
                    </div>

                        <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Amount</label>
                            <div className="col-sm-9">
                              <input type="text" name="amount" value={formdata.amount} onChange={formChangeData} className="form-control" />
                              {errors.amount && <small className="text-danger">{errors.amount}</small>}
                            </div>
                          </div>
                        </div>
                      
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Method</label>
                            <div className="col-sm-9">
                              <input className="form-control" name="method" value={formdata.method} onChange={formChangeData} />
                              {errors.method && <small className="text-danger">{errors.method}</small>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Transaction Id</label>
                            <div className="col-sm-9">
                              <input type="text" name="trans_id" value={formdata.trans_id} onChange={formChangeData} className="form-control" />
                              {errors.trans_id && <small className="text-danger">{errors.trans_id}</small>}
                            </div>
                          </div>
                        </div>
                      <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Status</label>
                            <div className="col-sm-9">
                              <select className="form-control" name="status" value={formdata.status} onChange={formChangeData}>
                                <option value="">-- Select Status --</option>
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                              {errors.status && <small className="text-danger">{errors.status}</small>}
                            </div>
                          </div>
                        </div>
                        
                      </div>
                      
                      <div className="row">
                        
                       {/* <div className="col-md-6">
                          <label>Image</label>
                          <input type="file" name="image" onChange={formChangeData} className="form-control" />
                          {errors.image && <small className="text-danger">{errors.image}</small>}
                        </div> */}
                        <div className="row mt-3">
                          <div className="col-md-12 text-center">
                            <button 
                              type="submit" 
                              className="btn btn-primary" 
                              >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default AddPayment